import React, { useMemo, useState } from 'react';
import { ForgeIcon, ForgeListItem } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';
import { StorySaveAsDialog } from './StorySaveAsDialog';

export function StorySaveAs({ onClick }: { onClick: () => void }) {
  return (
    <ForgeListItem onClick={onClick}>
      <ForgeIcon slot="start" name="save" />
      <button type="button">{I18n.t('derived_story.save_as')}</button>
    </ForgeListItem>
  );
}

export function useSaveAsModal() {
  const [saveAsDialogOpen, setSaveAsDialogOpen] = useState(false);

  const SaveAsListItem = useMemo(
    () => <StorySaveAs onClick={() => setSaveAsDialogOpen(true)} />,
    [setSaveAsDialogOpen],
  );
  const SaveAsDialog = useMemo(
    () => (
      <StorySaveAsDialog dialogOpen={saveAsDialogOpen} onCloseDialog={() => setSaveAsDialogOpen(false)} />
    ),
    [saveAsDialogOpen, setSaveAsDialogOpen],
  );

  return {
    SaveAsListItem,
    SaveAsDialog,
  };
}
